import React from 'react';

interface Props {
    label: string;
    value: string;
    lgValue?: boolean;
    inline?: boolean;
    labelMinWidth?: number;
    valueColour: string | null;
}

const LabelValue = ({
    label,
    value,
    lgValue,
    inline,
    labelMinWidth = 100,
    valueColour = null,
}: Props) => {
    return inline ? (
        <div className="flex" style={{alignItems: 'baseline'}}>
            <strong
                className="font-xs-2 grey"
                style={{minWidth: labelMinWidth}}>
                {label}
            </strong>
            <div className={`font-sm ${valueColour ? valueColour : ''}`}>
                {value}
            </div>
        </div>
    ) : (
        <>
            <strong className="font-xs-2 grey">{label}</strong>
            {lgValue ? (
                <strong
                    className={`${valueColour ? valueColour : ''}`}
                    style={{whiteSpace: 'pre-line'}}>
                    {value}
                </strong>
            ) : (
                <div className="font-sm">{value}</div>
            )}
        </>
    );
};

export default LabelValue;
